<template>
  <div
    class="team"
    :class="isListView ? 'list-view': ''"
  >
    <v-card
      elevation="2"
      tile
    >
      <div class="team-details">
        <v-card-title>
          {{ team.name }}
          <div class="team-buttons">
            <span
              v-if="team.full"
              class="material-symbols-rounded team-full-icon"
            >
              block
            </span>
            <v-dialog
              v-if="canEditTeam"
              v-model="editDialog"
              width="1000"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  id="`edit-team-${index}`"
                  class="edit-button"
                  v-bind="attrs"
                  icon
                  :outlined="false"
                  title="Edit this team"
                  v-on="on"
                >
                  <span class="material-symbols-rounded">
                    edit
                  </span>
                </v-btn>
              </template>
              <v-card>
                <team-edit
                  :current-user="currentUser"
                  :event-state="eventState"
                  :team="team"
                  @closeDialog="() => {editDialog = false}"
                />
              </v-card>
            </v-dialog>

            <v-dialog
              v-if="canJoinTeam"
              v-model="joinDialog"
              width="800"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  id="`team-${index}`"
                  v-bind="attrs"
                  class="join-team"
                  icon
                  :outlined="false"
                  title="Join this team"
                  v-on="on"
                >
                  <span class="material-symbols-rounded">
                    login
                  </span>
                </v-btn>
              </template>
              <v-card>
                <team-join
                  :current-user="currentUser"
                  :team="team"
                  @closeDialog="() => {joinDialog = false}"
                />
              </v-card>
            </v-dialog>

            <v-dialog
              v-if="canLeaveTeam"
              v-model="leaveDialog"
              width="500"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  id="`team-${index}`"
                  v-bind="attrs"
                  class="leave-team"
                  icon
                  :outlined="false"
                  title="Leave this team"
                  v-on="on"
                >
                  <span class="material-symbols-rounded">
                    logout
                  </span>
                </v-btn>
              </template>
              <v-card>
                <team-leave
                  :current-user="currentUser"
                  :team="team"
                  @closeDialog="() => {leaveDialog = false}"
                />
              </v-card>
            </v-dialog>

            <v-dialog
              v-if="canVoteOnTeam"
              v-model="voteDialog"
              width="1200"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  id="`team-${index}`"
                  v-bind="attrs"
                  class="vote-team"
                  icon
                  :outlined="false"
                  title="Vote on this team"
                  v-on="on"
                >
                  <span class="material-symbols-rounded">
                    how_to_vote
                  </span>
                </v-btn>
              </template>
              <v-card>
                <team-vote
                  :current-user="currentUser"
                  :team="team"
                  @closeDialog="() => {voteDialog = false}"
                />
              </v-card>
            </v-dialog>
          </div>
        </v-card-title>
        <v-card-subtitle>
          Leader: {{ team.leader.name }}
          <br>
          Members:
          <span v-if="team.members.length <= 0">
            <i>No members</i>
          </span>
          <span
            v-for="(member, index) in onlyMembers"
            :key="generateKeyFromEmail(member.email)"
          >
            {{ member.name }}<span
              v-if="onlyMembers.length > 1
                && index < team.members.length - 2"
            >, </span>
          </span>
          <span
            v-if="onlyMembers.length < 1"
          >
            None (yet!)
          </span>
        </v-card-subtitle>
        <v-card-text>
          {{ team.description }}
        </v-card-text>
        <!-- <v-card-text>
          <div v-if="eventState === 'Completed' && userBelongsToThisTeam">
            <team-results
              v-if="shouldShowResults"
              :event-state="eventState"
              :current-user="currentUser"
            />
            <v-btn
              v-else
              class="team-score"
              @click="toggleShowResults"
            >
              See team score
            </v-btn>
          </div>
        </v-card-text> -->
        <v-card-text
          v-if="canShowPresentationLink"
        >
          <p>View the presentation materials:</p>
          <p
            v-for="link in allPresentationMaterials"
            :key="`link-${link.id}`"
          >
            <a
              :href="link.link"
              :title="`View ${link.linkTitle}. This opens a new window.`"
              target="_blank"
            >
              {{ link.linkTitle }}
            </a>
          </p>
        </v-card-text>
        <v-card-text
          v-if="haveAlreadyVotedOnThisTeam && canVoteOnTeam"
          class="no-top-padding"
        >
          <i>Vote submitted <span class="material-symbols-rounded">check</span></i>
        </v-card-text>
        <v-card-text
          v-if=" canVote && !canVoteOnTeam"
          class="no-top-padding"
          style="color: rgba(0,0,0,.87)"
        >
          <strong>You belong to this team</strong>
        </v-card-text>
      </div>
    </v-card>
  </div>
</template>

<script>
// import TeamResults from './TeamResults.vue';

export default {
  name: 'Team',
  components: {
    TeamEdit: () => import('@/components/TeamEdit.vue'),
    TeamJoin: () => import('@/components/TeamJoin.vue'),
    TeamLeave: () => import('@/components/TeamLeave.vue'),
    TeamVote: () => import('@/components/TeamVote.vue'),
    // TeamResults,
  },
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
    eventState: {
      type: String,
      default: '',
    },
    isListView: {
      type: Boolean,
      default: false,
    },
    teamIndex: {
      type: Number,
      default: 0,
    },
    team: {
      type: Object,
      default: () => ({}),
    },
    selectedEvent: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      closeDialog: false,
      editDialog: false,
      joinDialog: false,
      leaveDialog: false,
      voteDialog: false,
      shouldShowResults: false,
    };
  },
  computed: {
    presentation() {
      const { links } = this.team;
      if (links.length === 0) {
        return undefined;
      }
      return links[links.length - 1];
    },
    allPresentationMaterials() {
      const { links } = this.team;
      return links;
    },
    presentationLink() {
      return this.presentation?.link || 'Presentation Link Not Found';
    },
    presentationLinkTitle() {
      return this.presentation?.linkTitle || 'Presentation Title Not Found';
    },
    userBelongsToThisTeam() {
      /* eslint-disable-next-line max-len */
      return this.team.members.filter((member) => member.email === this.currentUser.email).length > 0;
    },
    thisTeamHasAVote() {
      return this.$store.state.votes.filter((vote) => vote.team.id === this.team.id).length > 0;
    },
    canEditTeam() {
      return (this.currentUser.isAdmin
        || this.currentUser.email === this.team.leader.email)
        && (this.eventState === 'Registration'
        || this.eventState === 'Hacking'
        || this.eventState === 'Judging');
    },
    canShowPresentationLink() {
      return (this.eventState === 'Judging'
        || this.eventState === 'PrizeSelection'
        || this.eventState === 'Completed')
      || (this.eventState === 'Hacking' && (this.currentUser.isAdmin || this.userBelongsToThisTeam));
    },
    canJoinTeam() {
      return (this.team.members.length < this.$store.state.maxUsers) && this.currentUser.team === ''
        && (this.eventState === 'Registration' || this.eventState === 'Hacking') && !this.currentUser.isAdmin
        && !this.team.full;
    },
    canLeaveTeam() {
      return this.userBelongsToThisTeam && (this.eventState === 'Registration' || this.eventState === 'Hacking');
    },
    canVote() {
      return this.eventState === 'Judging' && this.currentUser.team !== '';
    },
    canVoteOnTeam() {
      return this.canVote && !this.userBelongsToThisTeam;
    },
    haveAlreadyVotedOnThisTeam() {
      if (this.userBelongsToThisTeam || !this.thisTeamHasAVote) {
        return false;
      }
      const teamVote = this.$store.state.votes.filter((vote) => vote.team.id === this.team.id)[0];
      // there is totally a better way to do this
      this.$store.state.teams.forEach((team, teamIndex) => {
        if (team.id === this.team.id) {
          // if we have a match, then we assign the score in state
          const voteInfo = {
            teamIndex,
            teamVote,
          };
          this.$store.commit('setVoteInfo', voteInfo);
          this.team.haveAlreadyVotedOnThisTeam = true;
        }
      });
      return true;
    },
    onlyMembers() {
      return this.team.members.filter((member) => member.email !== this.team.leader.email);
    },
  },
  methods: {
    generateKeyFromEmail(userEmail) {
      // will replace this with api call
      return userEmail.replace(/\s+/g, '-').toLowerCase().replace('.', '-').replace('@', '-');
    },
    toggleShowResults() {
      this.shouldShowResults = !this.shouldShowResults;
    },
  },
};
</script>

<style lang="scss" scoped>
.team {
  width: 33.33%;
  padding: 0 1em 1em 0;
  display: inline-block;
}

@media (max-width: 999px) {
  .team {
    width: 100%;
    display: block;
  }
}

.team.list-view {
  width: 100%;
  padding: 0 1em 1em 0;
  display: inline-block;
}

.team > .v-card {
  display: flex;
  flex-direction: row;
}

.team-image {
  width: 20%;
  background-size: cover;
  min-width: 200px;
}

.team-details {
  text-align: left;
  width: 100%;
}

.v-card__title {
  color: #f26522;
  padding-right: 100px;
  word-break: break-word;
}

.team-buttons {
  display: flex;
  position: absolute;
  right: 0;
  padding-right: 0.5em;
  color: #004e7d;
  background: white;
  max-width: 100px;
  top: 0.5em;

  .team-full-icon {
    padding-top: .25em;
  }
}

.v-btn {
  font-size: 1.15em !important;
  color: #004e7d !important;
  padding: 0.25em !important;

  &.team-score {
    padding: 1em !important;
    color: #fff !important;
    background: #004e7d !important;
    font-weight: normal;
    letter-spacing: 0.055em;
  }
}

.no-top-padding {
  padding-top: 0;
  color: green;
}
</style>
